import { createApiErrorHandler, useApiClient } from '@m43/core';
import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';
import { BoloResource } from '@mark43/cad-api';
import { useMutation } from '@tanstack/react-query';
import { useToast } from '@cad-arc';
import { errorOccurredWhile } from '../../../../common/helpers/error-occurred-while';
import { ContextMenuItem } from '../../../../context-menus/components/context-menu-item';

export function ExpireBoloItem({ boloId }: { boloId: number }) {
    const enabledFeatures = useEnabledFeatures();
    const apiClient = useApiClient();
    const toast = useToast();
    const expireBoloMutation = useMutation(
        (boloId: number) => {
            return apiClient.request<BoloResource.ExpireBolo>({
                method: 'POST',
                url: 'bolo/expire',
                data: { boloId },
            });
        },
        {
            onError: createApiErrorHandler(() => {
                toast({
                    status: 'error',
                    description: errorOccurredWhile('expiring BOLO'),
                });
            }),
        }
    );
    return (
        <ContextMenuItem
            contextMenuItemView={{
                isEnabled: true,
                isVisible: enabledFeatures.expireBolos,
                label: 'Expire BOLO',
            }}
            onSelect={() => expireBoloMutation.mutate(boloId)}
        />
    );
}
